<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col sm="3" md="2" xl="2" class="pt-1 pb-0">
          <v-row>
            <v-col cols="2" class="p-1">
              <v-btn
                  style="margin-top: 15px"
                  icon
                  color="dark-grey"
                  @click="moveDate(-1)"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-col>
            <v-col style="padding: 12px 0">
              <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="date"
                  persistent
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formatedDate"
                      label="Zeitraum"
                      prepend-icon="mdi-calendar"
                      readonly
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="date"
                    type="month"
                    scrollable
                    locale="de"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="modal = false"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="setDate(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="2" class="p-1">
              <v-btn
                  style="margin-top: 15px"
                  icon
                  color="dark-grey"
                  @click="moveDate(1)"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col class="pt-4 pb-0">
                      <span style="margin-top: auto;
                     margin-bottom: auto; margin-left: 12px;" class="text-h5">{{'Urlaubskalender: ' + monthsLong[currentMonth] + ' ' + currentYear}}</span>

        </v-col>
      </v-row>
      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-card class="rounded-lg" elevation="0" style="height: 100%; max-height: 100%">
          <v-simple-table id="printable-area"  class="px-2 pb-2 mt-4"
                          fixed-header ref="vuetifyTable">
            <template v-slot:default>
              <thead>
              <tr style="background: lightgrey; border: 2px solid rgba(0,0,0,0.42)">
                <th class="text-left font-weight-medium pl-6 font-weight-bold black--text  table-style" style="background: rgba(241,241,241); color: black !important; border-left: thin solid rgba(0, 0, 0, 0.12); min-width: 250px">Mitarbeiter</th>
                <th v-for="index in numberDaysInMonth" :key="index" class="text-center caption text-uppercase font-weight-bold black--text" style="background: rgba(241,241,241); color: black !important; border-left: thin solid rgba(0, 0, 0, 0.12)">
                  {{ getWeekdayDisplay(index) }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, i) in mitasFlat" :key="i" class="hover-row" >
                <td class="font-weight-medium pl-6  table-style" style="border-left: thin solid rgba(0, 0, 0, 0.12)">{{ truncateString(item.name) }}</td>
                <td v-for="index in numberDaysInMonth" :key="item.bis_id+index" class="text-center" :class="{
                  'cell-holiday': getValue(index, item.bis_id + '-') === 'H' || isWeekend(index),
                  'cell-urlb': getValue(index, item.bis_id + '-') === 'U',
                  'cell-fehl': getValue(index, item.bis_id + '-') === 'F',
                }">
                  <span v-if="!getValue(index, item.bis_id + '-') || getValue(index, item.bis_id + '-') === 'H'" class="grey--text text--lighten-2">—</span>
                  <span v-else :class="{
                  }" >{{ getValue(index, item.bis_id + '-') }}</span>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>

      </v-row>
      <v-row class="m-0" style="flex: 0 0 auto;" v-if="false">
        <v-col sm="3" md="2" xl="2" class="pt-1 pb-0">
          <v-row>
            <v-col cols="2" class="p-1">
              <v-btn
                  style="margin-top: 15px"
                  icon
                  color="dark-grey"
                  @click="moveDate(-1)"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </v-col>
            <v-col style="padding: 12px 0">
              <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="date"
                  persistent
                  width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formatedDate"
                      label="Zeitraum"
                      prepend-icon="mdi-calendar"
                      readonly
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="date"
                    type="month"
                    scrollable
                    locale="de"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                      text
                      color="primary"
                      @click="modal = false"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                      text
                      color="primary"
                      @click="setDate(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="2" class="p-1">
              <v-btn
                  style="margin-top: 15px"
                  icon
                  color="dark-grey"
                  @click="moveDate(1)"
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-list style="max-height: 88vh; overflow-y: auto">
            <v-list-item-group
                v-model="currentMita"
                @change="changeMita"
                multiple
                color="primary"
            >
              <v-list-item
                  v-for="(mita, i) in filteredItems"
                  :key="mita.bis_id"
                  :value="mita.bis_id"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="mita.name"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col class="pt-1 pb-0">
          <v-card
              style="width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;">
            <v-calendar
                ref="calendar"
                v-model="focus"
                color="blue"
                :weekday-format="myDayFormat"
                :month-format="myMonthFormate"
                :events="events"
                :event-color="getEventColor"
                :event-ripple="false"
                type="month"
                :weekdays="weekdayOrder"
                event-more-text="Mehr anzeigen"
            >
              <template v-slot:day-label="{day, present, month, year}">
                <v-row v-if="month==currentMonth" class="m-0" style="margin-top: -6px !important;">
                  <v-col v-if="!present" md="3" class="p-1"><v-btn fab  x-small depressed>{{day}}</v-btn></v-col>
                  <v-col v-else md="3" class="p-1 text-left"><v-btn fab  x-small depressed color="#63c2de">{{day}}</v-btn></v-col>
                </v-row>
                <v-row v-else class="m-0" style="margin-top: -6px !important;">
                  <v-col class="p-1" style="height: 40px"></v-col>
                </v-row>
              </template>
              <template v-slot:event="{ event, timed, eventSummary }" >
                <div  :class="[event.id !== 'created' ? 'clickable' : '', 'v-event-draggable']">
                  <!--component :is="{ render: eventSummary }"></component-->
                  <div class="v-event-summary" style="color: white">{{event.name}}</div>
                </div>
              </template>
            </v-calendar>
          </v-card>
          <v-overlay
              absolute
              :value="currentMita === undefined"
              style="
    margin-left: 12px;
    margin-right: 12px;
    margin-top: 4px;"
              opacity="0.1"
          >
            <v-row>
              <v-col>
              </v-col>
            </v-row>
          </v-overlay>
        </v-col>
      </v-row>
    </div>
  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import _orderBy from "lodash/orderBy"
import _throttle from "lodash/throttle"
import {getUid} from "@/shared/crypto";

export default {
  name: "calendar",
  data: () => ({
    mita_select: ['Mitarbeitergruppen', 'Mitarbeiter'],
    mita_select_value: 'Mitarbeiter',
    focus: '',
    migrs: [],
    mitas: [],
    mitasFlat: [],
    activeMita:[],
    weekdayOrder: [1, 2, 3, 4, 5, 6, 0],
    weekdays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    months: ["","Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
    currentMonth: 0,
    currentYear: 0,

    events: [],
    overlay: true,
    currentMita: [],
    userDays: [],
    holidays: [],

    date: new Date().toISOString().substr(0, 7),
    modal: false,
  }),
  computed: {
    numberDaysInMonth() {
      return new Date(this.currentYear, this.currentMonth, 0).getDate();
    },
    formatedDate() {
      let splits = this.date.split("-");
      return this.monthsLong[parseInt(splits[1])] + ", " + splits[0]
    },
    filteredItems() {
      return _orderBy(this.mitasFlat.filter(item => {
        if(!this.search) return this.mitasFlat;
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      }), 'name');
    },
  },
  mounted () {
    //this.$refs.calendar.updateTimes()
    this.currentMonth = new Date().getMonth() + 1;
    this.currentYear = new Date().getFullYear();
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/responsible_users'
    ).then(this.responseOkGet, this.responseError)
  },
  watch: {

  },
  methods: {
    getValue(day, bis_id) {
      let date = '' +this.currentYear + "-" + (this.currentMonth).toString().padStart(2, '0') + "-" + day.toString().padStart(2, '0')
      for (let i = 0; i < this.userDays.length; i++) {
        if (this.userDays[i].date === date && this.userDays[i].user_id === bis_id) {
          if (this.userDays[i].has_holiday) {
            return 'U';
          } else if (this.userDays[i].has_fehlzeit) {
            return 'F';
          }
          break;
        }
      }
      if (this.holidays[date]) {
        return 'H';
      }
      return null;
    },
    truncateString(str) {
      let maxLength = 25;
      if (str.length > maxLength) {
        return str.slice(0, maxLength - 3) + '...';
      }
      return str;
    },
    getWeekdayDisplay(day) {
      const date = new Date(this.currentYear, this.currentMonth - 1, day);
      return ('' + day).padStart(2, '0') + ' ' + this.weekdays[date.getDay()]; // 0 (Sunday) to 6 (Saturday)
    },
    isWeekend(day) {
      const date = new Date(this.currentYear, this.currentMonth - 1, day);
      const weekday = date.getDay();
      return weekday === 0 || weekday === 6; // Sunday or Saturday
    },
    moveDate(direction) {
      let curDate = new Date(this.date + "-01");
      let date = new Date(curDate.setMonth(curDate.getMonth() + direction)).toISOString().substring(0, 7);
      this.setDate(date);
    },
    clearError() {
      this.errorMessageStart = "";
      this.errorMessageEnd = "";
    },
    sortedItems(migr) {
      return _orderBy(this.mitas[migr], 'name');
    },
    clearSearch () {
      this.search="";
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      if (response.status === 200) {
        for (let i = 0; i < response.body.migrs.length; i++) {
          this.activeMita.push(null);
        }
        this.migrs = response.body.migrs;
        this.mitas = response.body.mita;
        for (let migr in this.mitas) {
          for (let i = 0; i < this.mitas[migr].length; i++) {
            this.mitas[migr][i].name = this.getMitaNameForGischl(this.mitas[migr][i]);
          }
        }
        for (let i = 0; i < response.body.mita_flat.length; i++) {
          let mita = response.body.mita_flat[i];
          mita.name = this.getMitaNameForGischl(mita);
          this.mitasFlat.push(mita)
        }
        for (let i = 0; i < this.filteredItems.length; i++) {
          this.currentMita.push(this.filteredItems[i].bis_id);
        }
        this.$http.post(
            Server_URL_ZK + '/zk/overview_holiday'+"?month=" + this.currentMonth + "&year=" + this.currentYear, this.currentMita
        ).then(this.responseOkGetOverview, this.responseError)
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkTrap(response) {
      this.hideLoader();
    },
    responseOkGetOverview(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.userDays = response.body.overviews;
        this.holidays = response.body.holidays;
        //this.calculateEvents();
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    changeMita() {
      if (this.currentMita !== undefined && this.currentMita !== null && this.currentMita.length > 0) {
        this.showLoader();
        this.$http.post(
            Server_URL_ZK + '/zk/overview_holiday'+"?month=" + this.currentMonth + "&year=" + this.currentYear, this.currentMita
        ).then(this.responseOkGetOverview, this.responseError)
      } else {
        this.userDays = [];
        this.calculateEvents();
      }
    },
    setDate(date) {
      this.$refs.dialog.save(date);
      this.date = date;
      this.focus = date+"-01";
      this.currentYear = parseInt(date.split("-")[0]);
      this.currentMonth = parseInt(date.split("-")[1]);
      this.changeMita();
      /*this.$nextTick(() => {
        this.currentMonth = this.$refs.calendar.parsedValue.month;
        this.currentYear = this.$refs.calendar.parsedValue.year;
        this.changeMita();
      });*/
    },
    myDayFormat(d) {
      return this.weekdays[d.weekday]
    },
    myMonthFormate(d) {
      return this.months[d.month]
    },
    getEventColor (event) {
      const rgb = parseInt(event.color.substring(1), 16)
      const r = (rgb >> 16) & 0xFF
      const g = (rgb >> 8) & 0xFF
      const b = (rgb >> 0) & 0xFF

      return event === this.createEventTimeLine
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          : event === this.createEvent
              ? `rgba(${r}, ${g}, ${b}, 0.7)`
              : event.color
    },
    getMitaNameForGischl(mita) {
      if (mita === null) {
        return null;
      }
      let searchString = mita.bis_id
      if (!mita.bis_id.includes("-")) {
        searchString += "-"
      }
      let res = JSON.parse(sessionStorage.getItem(searchString));
      if (res === null) {
        return value;
      }
      return res.first_name + " " + res.surname;
    },
    calculateEvents() {
      if (this.userDays === null || this.userDays.length === 0) {
        this.events = [];
        return;
      }
      let events = [];
      for (let i = 0; i < this.userDays.length; i++) {
        this.userDays[i].user_id = this.getMitaNameForGischl({bis_id: this.userDays[i].user_id});
      }
      // sort by user_id
      this.userDays.sort((a, b) => a.user_id.localeCompare(b.user_id))
      for (let i = 0; i < this.userDays.length; i++) {
        let start = new Date(`${this.userDays[i].date}T01:00`)
        let end = new Date(`${this.userDays[i].date}T23:00`)
        let name = this.userDays[i].user_id;
        if (this.userDays[i].has_holiday) {
          let color = "#095996";
          events.push({
            id: getUid(),
            name: "U " + name,
            start: start,
            end: end,
            color: color,
            timed: false,
          })
        }
        if (this.userDays[i].has_fehlzeit) {
          let color = "#ea5324"
          events.push({
            id: getUid(),
            name: "F " + name,
            start: start,
            end: end,
            color: color,
            timed: false,
          })
        }
      }
      this.events = events;
    },
    getCurrentMita(id) {
      for (let i = 0; i < this.mitasFlat.length; i++) {
        if (this.mitasFlat[i].id === id) {
          return this.mitasFlat[i];
        }
      }
      return null;
    },
    onBack() {
      window.history.back();
    },
    isFuture(day, present, month, year) {
      if (present) {
        return false
      }
      let today = new Date();
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      let date = new Date(year, month-1, day);
      return date > today;
    }
  }
}
</script>

<style lang="scss">

.v-calendar .v-event {
  pointer-events: none;
}
.clickable {
  pointer-events: auto !important;
}

.theme--light.v-label {
  color: black;
}


.v-calendar-weekly__head-weekday {
  color: black !important;
  background-color: #e4e5e6 !important;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  margin-right: -1px;
}

.soll-ist {
  margin-top: 4px;
}

.soll-ist.undefined {
  background-color: rgb(161, 149, 149) !important;
  border-color: rgb(161, 149, 149) !important;
  color: white;
}

.soll-ist.zero {
  background-color: rgb(240, 230, 140) !important;
  border-color: rgb(240, 230, 140) !important;
}

.soll-ist.neg {
  background-color: rgb(255, 69, 0)!important;
  border-color: rgb(255, 69, 0)!important;
  color: white;
}

.soll-ist.pos {
  background-color: rgb(1, 109, 3)!important;
  border-color: rgb(1, 109, 3)!important;
  color: white;
}

</style>

<style scoped lang="scss">

.v-list-item-group .v-list-item--active{
  background-color: #e4e5e6 !important;
}

::v-deep .v-list-item--link:before {
  background-color: transparent;
}

.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}

.v-radio::v-deep {
  align-self: flex-start;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

.v-radio::v-deep > .v-label {
  margin: 0;
}

::v-deep .saldo input {
  font-weight: 500;
}

::v-deep .pos input {
  color: green !important;
}

::v-deep .neg input {
  color: red !important;
}

::v-deep .v-list-item {
  min-height: 36px!important;
  padding: 0 8px!important;
}

::v-deep .v-list-item__content {
  padding: 8px 0!important;
}




</style>


<style scoped>
/* Custom styling to ensure the table looks clean */
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 0.75rem !important;
  color: #757575 !important;
}

/* Light hover effect */
.hover-row:hover {
  background-color: #f5f5f5 !important;
}

::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  height: 32px !important;
}

.table-divider {
  border-bottom: solid 2px #7c7c7c !important;
  border-top: solid 2px #7c7c7c !important;
}

.table-divider-l {
  border-left: solid 2px #7c7c7c !important;
  border-right: solid 2px #7c7c7c !important;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:not(.v-data-table__mobile-row) {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}


::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:not(.v-data-table__mobile-row) {
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.top-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  height: 20px; /* Needed for scrollbar visibility */
}

.dummy-content {
  height: 1px;
}


/* 1. Target both the Top Dummy Scroll and the Vuetify Table Wrapper */
.top-scroll,
::v-deep .v-data-table__wrapper {
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #90A4AE #CFD8DC; /* thumb color, track color */
}

/* 2. WebKit Browsers (Chrome, Edge, Safari) */

/* The Scrollbar container */
.top-scroll::-webkit-scrollbar,
::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  height: 10px; /* Height for horizontal scrollbar */
  width: 10px;  /* Width for vertical scrollbar */
}

/* The Track (background) */
.top-scroll::-webkit-scrollbar-track,
::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #CFD8DC; /* Light grey track */
  border-radius: 4px;
}

/* The Thumb (the moving handle) */
.top-scroll::-webkit-scrollbar-thumb,
::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: #90A4AE; /* Darker grey handle */
  border-radius: 4px; /* Rounded corners */
  border: 2px solid #CFD8DC; /* Creates a 'padding' effect around the thumb */
}

/* Hover effect for the thumb */
.top-scroll::-webkit-scrollbar-thumb:hover,
::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #607D8B; /* Darken on hover */
}

/* --- Layout Styles (From previous step) --- */
.top-scroll {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  /* Match the height defined in ::-webkit-scrollbar height + a little buffer if needed */
  height: 14px;
}
.dummy-content {
  height: 1px;
}

.table-style {
  position: sticky;
  left: 0;
  z-index: 6 !important;
  background-color: white;
}

</style>

<style scoped>
/* Table Border Styling to match the strict grid look */
.timesheet-table >>> table {
  border-collapse: collapse;
}

.timesheet-table >>> th,
.timesheet-table >>> td {
  border: 1px solid #e0e0e0;
  padding: 0 8px !important;
}

/* Header Styling */
.group-header {
  background-color: #f5f5f5;
  font-weight: bold;
  border-bottom: 1px solid #ccc;
}

.sub-header {
  font-size: 0.75rem;
  color: #666;
}

/* Row Coloring */
.row-weekend {
  background-color: #ffff99 !important; /* Yellow */
}

.row-weekend:hover {
  background-color: #ffff66 !important;
}

.row-holiday {
  background-color: #ffcccc !important; /* Light Red */
}

.row-holiday:hover {
  background-color: #ffaaaa !important;
}

.cell-holiday {
  background-color: rgba(241,241,241) !important;
}

.cell-urlb {
  background-color: #095996 !important;
  color: white !important;
}

.cell-fehl {
  background-color: #ea5324 !important;
  color: white !important;
}

/* Column Width Adjustments */
.fixed-width {
  width: 80px;
}

.pointer {
  cursor: pointer;
}

.pointer:hover {
  text-decoration: underline;
  text-decoration-style: solid;
}

</style>
